"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.TooltipPositions = exports.TooltipWidths = void 0;
var tooltipBase = 'luna-tooltip';
var targetBase = "".concat(tooltipBase, "-target");
var TooltipWidths = {
  medium: 'medium'
};
exports.TooltipWidths = TooltipWidths;
var TooltipPositions = {
  RightTop: 'right-top',
  RightMiddle: 'right-middle',
  RightBottom: 'right-bottom',
  TopMiddle: 'top-middle',
  BottomMiddle: 'bottom-middle',
  LeftTop: 'left-top',
  LeftMiddle: 'left-middle',
  LeftBottom: 'left-bottom'
};
exports.TooltipPositions = TooltipPositions;
var classes = {
  tooltip: tooltipBase,
  target: targetBase,
  hasIconAction: "".concat(targetBase, "-has_icon_action"),
  showOnHover: "".concat(tooltipBase, "-show-on-hover"),
  manualHide: "".concat(tooltipBase, "-hide"),
  manualShow: "".concat(tooltipBase, "-show"),
  positions: {
    rightTop: "".concat(tooltipBase, "-").concat(TooltipPositions.RightTop),
    rightMiddle: "".concat(tooltipBase, "-").concat(TooltipPositions.RightMiddle),
    rightBottom: "".concat(tooltipBase, "-").concat(TooltipPositions.RightBottom),
    topMiddle: "".concat(tooltipBase, "-").concat(TooltipPositions.TopMiddle),
    bottomMiddle: "".concat(tooltipBase, "-").concat(TooltipPositions.BottomMiddle),
    leftTop: "".concat(tooltipBase, "-").concat(TooltipPositions.LeftTop),
    leftMiddle: "".concat(tooltipBase, "-").concat(TooltipPositions.LeftMiddle),
    leftBottom: "".concat(tooltipBase, "-").concat(TooltipPositions.LeftBottom)
  },
  widths: {
    medium: "".concat(tooltipBase, "-width-medium")
  }
};
exports.classes = classes;
